export default {
    book: 'Rezervēt {product}',
    age_limit: 'Tikai vecākiem par {age} gadiem',
    change_plan: 'Mainīt plānu',
    upgrade_product: 'Uzlabot produktu',
    upgrade: 'Uzlabot',
    cancel_upgrade: 'Atcelt uzlabojumu',
    choose_product: 'Izvēlēties {product}',
    days: '{count} diena | {count} dienas',
    login_register: 'Pieteikties/Reģistrēties',
    current: 'Pašreizējais',
    keyless_benefits: {
        label: 'Tieši pie auto {0}',
        highlight: 'nomas serviss™',
        list: {
            cant_lose_the_key: 'Pilna apdrošināšana',
            zero_excess: 'Nav pašriska',
            phone_as_a_key: 'Telefons kā atslēga',
            straight_to_car: 'Nav jāgaida',
            no_queues: 'Nav rindas',
            online_id_check: 'Tiešsaistes ID pārbaude',
            self_checkout: 'Pašapkalpošanās izrakstīšanās',
        },
    },
};
